import { Modal, Seperator } from "@src/components";
import { Box, useTheme } from "@kolmeo/ui-core";
import React, { Children } from "react";
import ButtonV2 from "@kolmeo/ui-components/src/components/ButtonV2";
import { useBranding } from "@src/navigation/useBranding";
type LeaseSuccessModalProps = {
  isVisible: boolean;
  onClose: () => void;
  onViewInvoice: () => void;
  buttonLable?: string;
  title?: string;
  Children?: React.ReactNode;
  pendoId?: string;
};
const LeaseSuccessModal: React.FC<LeaseSuccessModalProps> = ({
  isVisible,
  onClose,
  onViewInvoice,
  title,
  Children,
  buttonLable,
  pendoId = "view-bond-invoice-btn"
}) => {
  const { brandingObject } = useBranding();
  const { colors } = useTheme();
  return (
    <Modal
      touchToDismiss
      isVisible={isVisible}
      toggleVisible={onClose}
      title={title ? title : "Welcome and congratulations on your new lease !"}
      presentationStyle="pageSheet"
      renderHeaderSeperator
      callToAction={
        <Box flexDirection="row" justifyContent="center" mt={3}>
          <ButtonV2
            data-usage-id={pendoId}
            label={buttonLable ? buttonLable : "View Bond Invoice"}
            width="100%"
            variant="primary"
            overrideVariant={{ bgColor: brandingObject?.primaryColor || colors.primary }}
            onPress={onViewInvoice}
          />
        </Box>
      }
    >
      {Children}
    </Modal>
  );
};
export default LeaseSuccessModal;
